var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-template',{staticClass:"page-contact",attrs:{"title":"Trabalhe Conosco"}},[_c('work-with-us',{staticClass:"mb-4 mb-md-0 mx-auto",attrs:{"action":_vm.server + '/rest/email/work-with-us'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }